import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Divider,
  Button,
  TextField,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Stack,
  useTheme,
  Badge,
  alpha,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { timer } from "rxjs"; // Assuming you use rxjs timer, else use setInterval
import {
  CHATSECRETKEY,
  P2PWEBSERVICE,
  showToast,
  WEBSERVICE,
} from "../../CoreDataService";
import axios from "axios";
import ChatIcon from "@mui/icons-material/Chat";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { useChat } from "../../Services/ChatService";
import ScrollableFeed from "react-scrollable-feed";
import CryptoJS from "crypto-js";
import moment from "moment";
import P2PNavbar from "./P2PNavbar";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const OrderDetailsPage = () => {
  const {
    message,
    onlineUsers,
    onlineBroker,
    p2pmessage,
    p2pmessageCustomer,
    p2pmessageCustomerAppeal,
    makeUserOnline,
    sendMessageToUser,
  } = useChat(); // Access state and methods

  const theme = useTheme();
  const themecolor = localStorage.getItem("theme");
  const navigate = useNavigate();
  const { btncolor } = useSelector((state) => state);

  const [counter, setCounter] = useState(900); // 15 minutes in seconds
  const [countDown, setCountDown] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [myUuid, setMyUuid] = useState(localStorage.getItem("uuid"));
  const [chatUserName, setChatUserName] = useState(
    localStorage.getItem("chatUserName")
  );
  const [orderCreatedTime, setOrderCreatedTime] = useState(
    localStorage.getItem("orderCreationTime")
  );

  const [counterPartyUuid, setCounterPartyUuid] = useState(
    localStorage.getItem("counterPartyUuid")
  );
  const [previousPrice, setPreviousPrice] = useState(
    localStorage.getItem("previousPageBuyprice")
  );
  const [previousAmount, setPreviousAmount] = useState(
    localStorage.getItem("previousPageBuyAmount")
  );
  const [orderId, setOrderId] = useState(
    localStorage.getItem("previousOrderId")
  );
  const [adId, setAdId] = useState(localStorage.getItem("previousAdId"));
  const [previousTotalAmount, setPreviousTotalAmount] = useState(
    localStorage.getItem("previousPageBuyTotalAmount")
  );
  const [previousOrderCrypto, setPreviousOrderCrypto] = useState(
    localStorage.getItem("orderCrypto")
  );
  const [previousOrderFiat, setPreviousOrderFiat] = useState(
    localStorage.getItem("orderfiat")
  );
  const [bankTransferPaymentMethodList, setBankTransferPaymentMethodList] =
    useState([]);
  const [walletServicePaymentMethodList, setWalletServicePaymentMethodList] =
    useState([]);
  const [showAppealModal, setShowAppealModal] = useState(false);
  const [showAppealSubmitModal, setShowAppealSubmitModal] = useState(false);

  const [appealReasonId, setAppealReasonId] = useState("");
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);
  const [isAppealExist, setIsAppealExist] = useState(false);
  const [appealCreatedOn, setAppealCreatedOn] = useState("");
  const [appealStatus, setAppealStatus] = useState("");

  const [appealReasonList, setAppealReasonList] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [nickname, setNickname] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [profileImageLink, setProfileImageLink] = useState("");
  const [userId, setUserId] = useState("");

  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [showDialogBankDetails, setShowDialogBankDetails] = useState(false);
  const [selectedWalletDetails, setSelectedWalletDetails] = useState(null);
  const [showDialogWalletDetails, setShowDialogWalletDetails] = useState(false);

  const [p2pPreviousMessage, setP2pPreviousMessage] = useState([]);
  const [groupChatUserList, setGroupChatUserList] = useState([]);
  const messagesEndRef = useRef(null);
  const [messageText, setMessageText] = useState("");
  const [isOnline, setIsOnline] = useState(true);
  const [appealUploadFile, setAppealUploadFile] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [notified, setNotified] = useState(false);

  // const [messages, setMessages] = useState([
  //     {
  //         id: 1,
  //         sender: 'Bullish',
  //         content: 'Hey, how are you doing?',
  //         time: '10:15 AM',
  //         isSender: true, // true for self, false for other user
  //     },
  //     {
  //         id: 2,
  //         sender: 'Seller',
  //         content: 'I am good, thanks! What about you?',
  //         time: '10:16 AM',
  //         isSender: false, // true for self, false for other user
  //     },
  //     {
  //         id: 3,
  //         sender: 'Bullish',
  //         content: 'I am doing great, thanks for asking!',
  //         time: '10:17 AM',
  //         isSender: true, // true for self, false for other user
  //     },
  //     {
  //         id: 4,
  //         sender: 'Bullish',
  //         content: 'Hey, how are you doing?',
  //         time: '10:15 AM',
  //         isSender: true, // true for self, false for other user
  //     },
  //     {
  //         id: 5,
  //         sender: 'Seller',
  //         content: 'I am good, thanks! What about you?',
  //         time: '10:16 AM',
  //         isSender: false, // true for self, false for other user
  //     },
  //     {
  //         id: 6,
  //         sender: 'Bullish',
  //         content: 'I am doing great, thanks for asking!',
  //         time: '10:17 AM',
  //         isSender: true, // true for self, false for other user
  //     },
  //     {
  //         id: 7,
  //         sender: 'Bullish',
  //         content: 'Hey, how are you doing?',
  //         time: '10:15 AM',
  //         isSender: true, // true for self, false for other user
  //     },
  //     {
  //         id: 8,
  //         sender: 'Seller',
  //         content: 'I am good, thanks! What about you?',
  //         time: '10:16 AM',
  //         isSender: false, // true for self, false for other user
  //     },
  //     {
  //         id: 9,
  //         sender: 'Bullish',
  //         content: 'I am doing great, thanks for asking!',
  //         time: '10:17 AM',
  //         isSender: true, // true for self, false for other user
  //     },
  // ]);

  // You can define appealReasonList from API or state
  // const appealReasonList = [
  //     { appealReasonId: 1, appealReasonDetails: "Didn't receive payment" },
  //     { appealReasonId: 2, appealReasonDetails: "Scam suspicion" },
  // ];

  useEffect(() => {
    // Get the current date and time
    getUserInfo();
    getOrderStatus();
    getCurrentDateTime();
    getAllPaymentMethodByUser();
    getAppealStatus();
    getAppealReasons();
    createTraderChat();
    // getPreviousChatData();

    // Start countdown timer from 15 minutes (900 seconds)
    const startDate = new Date(orderCreatedTime);
    const endDate = new Date();
    let initialSeconds =
      900 - Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
    if (initialSeconds <= 0) {
      initialSeconds = 0; // Timer starts from 0 if 15 minutes are already over
    }

    setCounter(initialSeconds);

    // Start countdown timer
    const tick = 1000; // 1 second
    const countdown = timer(0, tick).subscribe(() => {
      setCounter((prevCounter) => {
        if (prevCounter > 0) {
          return prevCounter - 1;
        } else {
          countdown.unsubscribe(); // Stop the timer once it reaches 0
          return 0;
        }
      });
    });

    setCountDown(countdown);

    return () => {
      if (countdown) {
        countdown.unsubscribe(); // Clean up the timer on component unmount
      }
    };
  }, [orderCreatedTime]);

  useEffect(() => {
    // Function to decrypt the message
    const decryptMessage = (encryptedMessage) => {
      const bytes = CryptoJS.AES.decrypt(encryptedMessage, CHATSECRETKEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    };

    // Function to handle new incoming message
    const handleNewMessage = (val) => {
      //   const decryptedMessage = decryptMessage(val.message);
      const addedMessage = {
        message: val.message,
        date: val.date,
        time: val.time,
        fromuser: val.user,
        matched: "false",
      };

      setP2pPreviousMessage((prevMessages) => [...prevMessages, addedMessage]);
    };

    // Simulate receiving a new message
    if (p2pmessage) {
      handleNewMessage(p2pmessage);
    }

    // Cleanup the effect
    return () => {
      // Unsubscribe if needed
    };
  }, [p2pmessage, CHATSECRETKEY]);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [p2pPreviousMessage]);

  // Simulating scroll to bottom function (this will depend on your implementation)

  // Get previous chat data
  const getPreviousChatData = async () => {
    // setLoading(true);

    const jsonObj = {
      groupId: parseInt(orderId),
      pageNo: 1,
      pageSize: 100,
      fromUserUuid: myUuid,
    };

    try {
      const response = await axios.post(
        WEBSERVICE + "user/getP2pChatMessages", // Replace with the actual API URL
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const { groupChatUserList, chatMessageList } = response.data;

      let processedMessages = chatMessageList || [];
      if (processedMessages.length > 0) {
        processedMessages = processedMessages.map((message) => {
          const matchingUser = groupChatUserList.find(
            (user) => user.userUuid === message.fromuser
          );
          if (matchingUser) {
            message.username = matchingUser.userName;
          }
          return message;
        });
      }

      // Reverse the messages and update state
      setGroupChatUserList(groupChatUserList);
      setP2pPreviousMessage(processedMessages.reverse());
    } catch (error) {
      console.error("Error fetching previous chat data:", error);
    } finally {
      //   setLoading(false);
    }
  };

  const createTraderChat = async () => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/createP2pChat`,
        {
          groupId: parseInt(orderId),
          groupChatUsers: [
            { userUuid: myUuid, userType: "TRADER" },
            { userUuid: counterPartyUuid, userType: "TRADER" },
          ],
          fromUserUuid: myUuid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      getPreviousChatData();
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const sendMessageToTrader = (message) => {
    // Check if the message is empty
    if (!message.trim()) {
      showToast("error", "Cannot leave blank");
      return;
    }

    if (p2pPreviousMessage?.length === 0) {
      createTraderChat();
    }

    const dateToday = moment().format("DD MMMM YYYY");
    const encryptedMessage = CryptoJS.AES.encrypt(
      message,
      CHATSECRETKEY
    ).toString();
    const base64Message = CryptoJS.enc.Base64.parse(encryptedMessage);
    const encryptedData = base64Message.toString(CryptoJS.enc.Hex);

    // Prepare message data
    const messageData = {
      date: dateToday,
      user: myUuid,
      id: 1, // You can adjust this ID as needed
      message: message,
      status: 1, // Message status (1 for sent)
      time: new Date().toLocaleTimeString(),
      group: parseInt(orderId), // Group chat ID (orderId in your case)
    };

    // Send message to backend via chat service
    sendMessageToUser("sendp2pmessage", messageData);

    // Update previous messages state (if needed)
    if (!p2pPreviousMessage) {
      setP2pPreviousMessage([]);
    }

    // Clear message input after sending
    setMessageText("");
  };

  const getUserInfo = async () => {
    const jsonObj = {
      uuid: myUuid,
      usersUuid: counterPartyUuid,
    };

    try {
      const response = await axios.post(
        WEBSERVICE + "/crypto/banking/p2p/getP2PUserDetailsForOther",
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const user = response.data.userDetails[0];
      setUserDetails(user);

      // Set nickname
      const userNickname = user.nickName ? user.nickName : user.name;
      setNickname(userNickname);
      setFirstLetter(userNickname.charAt(0));

      // Set profile picture and image link
      setProfilePic(user.profilePic);
      setUserId(user.userId);

      if (user.profilePic) {
        setProfileImageLink(
          `https://userkycdoc.s3.us-west-1.amazonaws.com/user_id_${user.userId}/${user.profilePic}`
        );
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Months are 0-based, so add 1
    const currentDay = currentDate.getDate();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();
    const currentSecond = currentDate.getSeconds();
    setCurrentDateTime(
      `${currentYear}-${currentMonth}-${currentDay} ${currentHour}:${currentMinute}:${currentSecond}`
    );
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const paymentData = {
    bankTransfers: [
      { accountHolder: "kundan", bankName: "hmm Ben" },
      { accountHolder: "kundan", bankName: "IDFC" },
    ],
    walletServices: [
      { providerName: "phonepay", walletId: "prasad.kundan681-1@okaxis" },
      { providerName: "Gpay", walletId: "prasad.kundan681-1@okaxis" },
    ],
  };

  const [tab, setTab] = useState(0);
  const handleTabChange = (_, newValue) => setTab(newValue);

  const getAllPaymentMethodByUser = async () => {
    try {
      const uuid = counterPartyUuid;
      const accessToken = localStorage.getItem("access_token");

      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllPaymentMethodByUser`,
        { uuid },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const { error, error_msg, paymentDetails } = response.data;

      if (error?.error_data === 0 && Array.isArray(paymentDetails)) {
        const bankMethods = [];
        const walletMethods = [];

        paymentDetails.forEach((method) => {
          if (method.paymentMethodName === "BANK TRANSFER") {
            let identificationType = "";
            let identificationNumber = "";

            if (method.ifscCode) {
              identificationType = "IFSC CODE";
              identificationNumber = method.ifscCode;
            } else if (method.swiftCode) {
              identificationType = "SWIFT CODE";
              identificationNumber = method.swiftCode;
            } else if (method.routingNo) {
              identificationType = "ROUTING NO";
              identificationNumber = method.routingNo;
            }

            bankMethods.push({
              accountHolderName: method.profileName,
              bankName: method.bankName,
              pmDetailsId: method.pmDetailsId,
              accountNo: method.accountNo,
              accountType: method.accountType,
              identificationType,
              identificationNumber,
              bankAddress: method.bankAddress,
            });
          } else {
            walletMethods.push({
              paymentProviderName: method.paymentProviderName,
              walletId: method.vpa,
              pmDetailsId: method.pmDetailsId,
              email_id: method.emailId,
              phone_number: method.mobileNo,
              profileName: method.profileName,
            });
          }
        });

        console.log("BankTransferPaymentMethodList", bankMethods);
        console.log("walletTransferPaymentMethodList", walletMethods);

        setBankTransferPaymentMethodList(bankMethods);
        setWalletServicePaymentMethodList(walletMethods);
      } else {
        showToast("error", error_msg || "Failed to fetch payment methods");
        setBankTransferPaymentMethodList([]);
        setWalletServicePaymentMethodList([]);
      }
    } catch (error) {
      showToast("error", "Something went wrong while fetching payment methods");
      setBankTransferPaymentMethodList([]);
      setWalletServicePaymentMethodList([]);
    }
  };

  const notifySeller = () => {
    const jsonObj = {
      confirm: 1,
      orderId: parseInt(localStorage.getItem("previousOrderId")),
      adId: parseInt(localStorage.getItem("previousAdId")),
    };
    const jsonString = JSON.stringify(jsonObj);

    // setLoading(true); // Set loading to true while the request is being made

    axios
      .post(WEBSERVICE + "crypto/banking/p2p/notifySeller", jsonString, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        //   setLoading(false); // Set loading to false after the request finishes
        if (response.data.error.error_data === 0) {
          showToast("success", "Seller is notified ");
          setNotified(true); // Set notified state to true
          getOrderStatus();
          // Success: navigate to the "my-orders" page
          // navigate('/p2p/my-orders');
        } else {
          // Error: show an alert (or use your custom alert system)
          showToast("error", response.data.error.error_msg); // This could be replaced by a custom alert component
        }
      })
      .catch((error) => {
        //   setLoading(false); // Set loading to false in case of error
        console.error("Error notifying seller:", error);
        showToast("error", "An error occurred while notifying the seller.");
      });
  };

  const checkOnlineUser = (targetUserId) => {
    return onlineUsers?.some((user) => user.userId === targetUserId);
  };

  // Order Cancel Handler
  const orderCancel = async () => {
    // setStpLoader(true); // Show loader while the request is in progress
    const jsonObj = { orderId: orderId };
    const jsonString = JSON.stringify(jsonObj);

    try {
      const response = await axios.post(
        P2PWEBSERVICE + "/orderCancel",
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error_data === 0) {
        getOrderStatus(); // If cancel is successful, check order status
      } else {
        showToast("error", response.data.error_msg); // Show error message if cancel fails
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      showToast("error", "An error occurred while cancelling the order.");
    } finally {
      //   setStpLoader(false); // Hide loader after the request completes
    }
  };

  // Get Order Status Handler
  const getOrderStatus = async () => {
    // setStpLoader(true); // Show loader while the request is in progress
    const jsonObj = { orderId: orderId };
    const jsonString = JSON.stringify(jsonObj);

    try {
      const response = await axios.post(
        P2PWEBSERVICE + "/getOrderStatus",
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      //   setStpLoader(false); // Hide loader after the request completes

      const apiMessage = response.data.errorResponse.error_data;
      const apiMessageText = response.data.errorResponse.error_msg;

      if (apiMessage === 0) {
        const orderStatus = response.data.status;
        setOrderStatus(orderStatus);
        if (orderStatus === "CANCELLED") {
          localStorage.setItem("orderStatus", "cancel");
        } else {
          localStorage.setItem("orderStatus", orderStatus);
        }
        // setOrderStatus(orderStatus); // Update state with new order status
      } else {
        showToast("error", apiMessageText); // Show error message if the status request fails
      }
    } catch (error) {
      //   setStpLoader(false); // Hide loader on error
      console.error("Error fetching order status:", error);
      showToast("error", "An error occurred while fetching the order status.");
    }
  };

  const getAppealReasons = async () => {
    try {
      const response = await axios.get(P2PWEBSERVICE + "/getAppealReasons", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      });

      const { error: apiError, error_msg, appealReasons } = response.data;

      if (apiError.error_data === 0) {
        if (appealReasons.length > 0) {
          setAppealReasonList(
            appealReasons.map((reason) => ({
              appealReasonId: reason.appealReasonId,
              appealReasonDetails: reason.appealReasonDetails,
            }))
          );
        } else {
          setAppealReasonList([]);
        }
      } else {
        showToast("error", error_msg);
        // setError(error_msg);
      }
    } catch (err) {
      showToast("error", "An error occurred while fetching appeal reasons.");
      console.error(err);
    } finally {
      //   setLoading(false);
    }
  };

  const reorder = async () => {
    localStorage.setItem("counterPartyUuid", counterPartyUuid);
    localStorage.setItem("previousOrderId", orderId);
    localStorage.setItem("uuid", myUuid);
    navigate(`/p2p/public-profile/${counterPartyUuid}`);

    // this.route.navigate(['/p2p/public-profile/', this.myUuid]);
    // showToast("success", "Go to public profile page");
  };

  const getAppealStatus = async () => {
    // setStpLoader(true); // Show loader

    const jsonObj = {
      orderId: Number(orderId), // Make sure orderId is a number
    };
    const jsonString = JSON.stringify(jsonObj);

    try {
      const response = await axios.post(
        P2PWEBSERVICE + "/getAppealStatus",
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      //   setStpLoader(false); // Hide loader after request completes

      const { appealStatus, appealCreatedOn } = response.data;
      setAppealStatus(appealStatus);
      setAppealCreatedOn(appealCreatedOn);

      if (appealStatus !== null) {
        // Set localStorage items as in Angular code
        localStorage.setItem("previousAdId", adId);
        localStorage.setItem("previousOrderId", orderId);
        localStorage.setItem("counterPartyUuid", counterPartyUuid);
        localStorage.setItem("chatUserName", chatUserName);
        localStorage.setItem("appealCreationTime", appealCreatedOn);

        // // Profile Picture
        localStorage.setItem("profilePic", profilePic);
        localStorage.setItem("profileImageLink", profileImageLink);
        localStorage.setItem("firstLetter", firstLetter);

        // Update appeal step based on appeal status
        if (appealStatus === "Appeal Submitted") {
          localStorage.setItem("appeal-step", "2");
          localStorage.setItem("appeal-step-text", "Appeal Pending");
        } else if (appealStatus === "CS Review") {
          localStorage.setItem("appeal-step", "3");
          localStorage.setItem("appeal-step-text", "Appeal sent to CS");
        } else if (appealStatus === "Appeal Completed") {
          localStorage.setItem("appeal-step", "4");
          localStorage.setItem("appeal-step-text", "Appeal Completed");
        } else if (appealStatus === "Appeal Cancelled") {
          localStorage.setItem("appeal-step", "0");
          localStorage.setItem("appeal-step-text", "Appeal Got Cancelled");
        }

        setIsAppealExist(true); // Set appealExist to true if appeal status is found
      } else {
        setIsAppealExist(false); // No appeal exists
      }
    } catch (error) {
      //   setStpLoader(false); // Hide loader on error
      console.error("Error fetching appeal status:", error);
      showToast("error", "Failed to fetch appeal status.");
    }
  };

  // Handle opening of dialog
  const handleOpenDialog = (bankDetails) => {
    setSelectedBankDetails(bankDetails);
    setShowDialogBankDetails(true);
  };

  // Handle closing of dialog
  const handleCloseDialog = () => {
    setShowDialogBankDetails(false);
    setSelectedBankDetails(null);
  };

  const handleOpenDialogWallet = (walletDetails) => {
    setSelectedWalletDetails(walletDetails);
    setShowDialogWalletDetails(true);
  };

  const handleCloseDialogWallet = () => {
    setShowDialogWalletDetails(false);
    setSelectedWalletDetails(null);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // gets the first file
    console.log("Selected file:", file);
    setAppealUploadFile(file); // store the single file in state
  };

  const createAppeal = async () => {
    if (description.length > 500) {
      showToast(
        "error",
        "Appeal Description text length cannot be greater than 500."
      );
      return;
    }

    if (!appealUploadFile) {
      showToast("error", "Please select a file for upload.");
      return;
    }

    const formData = new FormData();
    formData.append("uuid", localStorage.getItem("uuid"));
    formData.append("appealReasonId", appealReasonId);
    formData.append("orderId", orderId);
    formData.append("adId", adId);
    formData.append("appealStatusId", 0);
    formData.append("description", description);
    formData.append("proof", appealUploadFile);

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/createAppeal`,
        formData,
        {
          headers: {
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const res = response.data;

      if (res.error?.error_data === 0) {
        showToast("success", "Appeal Created Successfully!");

        localStorage.setItem("previousAdId", adId);
        localStorage.setItem("previousOrderId", orderId);
        localStorage.setItem("counterPartyUuid", counterPartyUuid);
        localStorage.setItem("chatUserName", nickname);
        localStorage.setItem("appealCreationTime", res.appealCreatedOn);
        localStorage.setItem("appeal-step", "2");
        localStorage.setItem("appeal-step-text", "Appeal Pending");
        localStorage.setItem("profilePic", profilePic);
        localStorage.setItem("profileImageLink", profileImageLink);
        localStorage.setItem("firstLetter", firstLetter);

        // Optionally reset file input
        setAppealUploadFile(null);
        setShowAppealSubmitModal(false);

        // Close modal (depends on how you handle it)
        // if (appealSubmitModal?.current) {
        //   appealSubmitModal.current.close(); // Or your close handler
        // }

        // Open new tab
        setTimeout(() => {
          window.open("/p2p/p2p-appeal-progress", "_blank");
        }, 1000);

        getAppealStatus();
      } else {
        showToast("error", res.error?.error_msg || "Something went wrong");
      }
    } catch (err) {
      showToast("error", "An error occurred while creating appeal");
    }
  };

  return (
    <>
      <P2PNavbar />
      <Box sx={pageWrapper}>
        {/* Status header */}
        <Box sx={statusHeader}>
          <Typography sx={statusTitle}>
            {counter != 0 ? orderStatus : "CANCELLED"}
          </Typography>
          {counter != 0 &&
          (orderStatus == "PROCESSING" || orderStatus == "PENDING") ? (
            <Typography variant="body2" sx={{ mt: 0.5, color: "var(--text-color)", opacity: 0.75 }}>
              Pay the seller within{" "}
              <strong style={{ color: btncolor }}>
                {formatTime(counter)}
              </strong>
            </Typography>
          ) : null}
        </Box>

        {/* Two-column layout */}
        <Box sx={twoColLayout}>
          {/* Left column: order info */}
          <Box sx={leftPanel}>
            {/* Step 1: Order Info */}
            <Typography sx={sectionTitle}>1. Confirm Order Info</Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 2,
                mb: 2.5,
              }}
            >
              <Box>
                <Typography sx={{ fontSize: "0.78rem", opacity: 0.6, color: "var(--text-color)", mb: 0.5 }}>
                  Amount
                </Typography>
                <Typography sx={{ fontWeight: 700, color: btncolor }}>
                  {Number(previousTotalAmount)?.toFixed(6)}{" "}
                  {previousOrderFiat}
                </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontSize: "0.78rem", opacity: 0.6, color: "var(--text-color)", mb: 0.5 }}>
                  Price
                </Typography>
                <Typography sx={{ fontWeight: 700, color: btncolor }}>
                  {Number(previousPrice)?.toFixed(6)} {previousOrderFiat}
                </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontSize: "0.78rem", opacity: 0.6, color: "var(--text-color)", mb: 0.5 }}>
                  Receive Quantity
                </Typography>
                <Typography sx={{ fontWeight: 700, color: btncolor }}>
                  {Number(previousAmount)?.toFixed(6)} {previousOrderCrypto}
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ my: 2.5, borderColor: "rgba(125,125,125,0.15)" }} />

            {/* Step 2: Make Payment */}
            <Box sx={{ mt: 2 }}>
              <Typography sx={sectionTitle}>2. Make Payment</Typography>
              <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)", opacity: 0.75, mb: 1.5 }}>
                Transfer the funds to the seller's account provided below
              </Typography>

              <Tabs
                value={tab}
                onChange={handleTabChange}
                textColor="inherit"
                sx={{
                  "& .MuiTabs-indicator": { backgroundColor: btncolor },
                  "& .MuiTab-root": {
                    color: "var(--text-color)",
                    opacity: 0.65,
                    fontWeight: 600,
                    fontSize: "0.82rem",
                    textTransform: "none",
                    minHeight: 44,
                    "&.Mui-selected": { color: btncolor, opacity: 1 },
                  },
                }}
                scrollButtons="auto"
              >
                <Tab
                  label={`BANK TRANSFER (${bankTransferPaymentMethodList?.length})`}
                />
                <Tab
                  label={`WALLET SERVICES (${walletServicePaymentMethodList?.length})`}
                />
              </Tabs>

              {/* Bank Transfer */}
              {tab === 0 && (
                <TableContainer sx={modernTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={tableHeadRow}>
                        <TableCell sx={tableHeadCell}>Account Holder's Name</TableCell>
                        <TableCell sx={tableHeadCell}>Bank Name</TableCell>
                        <TableCell sx={tableHeadCell}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bankTransferPaymentMethodList.map((row, idx) => (
                        <TableRow key={idx} sx={tableBodyRow}>
                          <TableCell sx={tableBodyCell}>
                            <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}>
                              {row.accountHolderName}
                            </Typography>
                          </TableCell>
                          <TableCell sx={tableBodyCell}>{row.bankName}</TableCell>
                          <TableCell sx={tableBodyCell}>
                            <VisibilityIcon
                              onClick={() => handleOpenDialog(row)}
                              sx={{ cursor: "pointer", color: "var(--text-color)", opacity: 0.7, fontSize: "1.2rem" }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {/* Wallet Services */}
              {tab === 1 && (
                <TableContainer sx={modernTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={tableHeadRow}>
                        <TableCell sx={tableHeadCell}>Payment Provider Name</TableCell>
                        <TableCell sx={tableHeadCell}>Wallet ID</TableCell>
                        <TableCell sx={tableHeadCell}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {walletServicePaymentMethodList.map((row, idx) => (
                        <TableRow key={idx} sx={tableBodyRow}>
                          <TableCell sx={tableBodyCell}>
                            <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}>
                              {row.paymentProviderName}
                            </Typography>
                          </TableCell>
                          <TableCell sx={tableBodyCell}>{row.walletId}</TableCell>
                          <TableCell sx={tableBodyCell}>
                            <VisibilityIcon
                              onClick={() => handleOpenDialogWallet(row)}
                              sx={{ cursor: "pointer", color: "var(--text-color)", opacity: 0.7, fontSize: "1.2rem" }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>

            {/* Step 3: Notify Seller */}
            {counter !== 0 ? (
              <Box sx={{ mt: 3 }}>
                <Typography sx={sectionTitle}>3. Notify Seller</Typography>
                <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)", opacity: 0.75, mb: 2 }}>
                  After transferring the funds, click on the "Transferred,
                  notify seller" button.
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 2,
                  }}
                >
                  {orderStatus == "PROCESSING" ? (
                    <ContainedButton
                      variant="contained"
                      onClick={() => reorder()}
                    >
                      Reorder
                    </ContainedButton>
                  ) : (
                    <>
                      <ContainedButton
                        variant="contained"
                        onClick={() => notifySeller()}
                      >
                        Transferred, notify seller
                      </ContainedButton>
                      <OutlinedButton
                        variant="outlined"
                        onClick={orderCancel}
                      >
                        Cancel Order
                      </OutlinedButton>
                    </>
                  )}
                </Box>
              </Box>
            ) : (
              <Box sx={{ mt: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 2,
                  }}
                >
                  <ContainedButton
                    variant="contained"
                    onClick={() => reorder()}
                  >
                    Reorder
                  </ContainedButton>

                  {isAppealExist ? (
                    <OutlinedButton
                      variant="outlined"
                      onClick={(e) => setShowAppealModal(true)}
                    >
                      Appeal
                    </OutlinedButton>
                  ) : (
                    <OutlinedButton
                      variant="outlined"
                      onClick={(e) => orderCancel()}
                    >
                      Show Appeal Progress Status
                    </OutlinedButton>
                  )}
                </Box>
              </Box>
            )}
          </Box>

          {/* Right column: chat */}
          <Box sx={rightPanel}>
            {/* Chat Header */}
            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid rgba(125,125,125,0.12)",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                variant="dot"
                sx={{
                  "& .MuiBadge-dot": {
                    backgroundColor: checkOnlineUser(userDetails?.usersUuid)
                      ? "green"
                      : "gray",
                    width: 10,
                    height: 10,
                  },
                }}
              >
                <Avatar src="/avatar.png" alt={nickname} />
              </Badge>
              <Typography sx={{ fontWeight: 600, color: "var(--text-color)", fontSize: "0.95rem" }}>
                {nickname}
              </Typography>
            </Box>

            {/* Message list */}
            <Box sx={{ flex: 1, overflow: "hidden" }}>
              <ScrollableFeed>
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    p: 2,
                    minHeight: "50vh",
                    maxHeight: "50vh",
                  }}
                >
                  {p2pPreviousMessage.map((message) => (
                    <Box
                      key={message.id}
                      sx={{
                        display: "flex",
                        flexDirection:
                          message.fromuser == myUuid ? "row-reverse" : "row",
                        alignItems: "center",
                        gap: 1,
                        marginBottom: 2,
                        mr: 1,
                      }}
                    >
                      <Avatar
                        src={
                          message.fromuser == myUuid
                            ? "/avatar.png"
                            : "/avatar2.png"
                        }
                        alt={message.sender}
                      />
                      <Box
                        sx={{
                          maxWidth: "100%",
                          bgcolor:
                            message.fromuser == myUuid
                              ? alpha(btncolor, 0.15)
                              : "var(--body-color-less2)",
                          color: "var(--text-color)",
                          p: 1.5,
                          borderRadius: 2,
                          display: "flex",
                          flexDirection: "column",
                          alignItems:
                            message.fromuser == myUuid
                              ? "flex-end"
                              : "flex-start",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ wordWrap: "break-word", color: "var(--text-color)" }}
                        >
                          {message.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ marginTop: 0.5, color: "var(--text-color)", opacity: 0.55 }}
                        >
                          {message.time}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                  <div ref={messagesEndRef} />
                </Box>
              </ScrollableFeed>
            </Box>

            {/* Chat input */}
            <Box
              sx={{
                p: 2,
                borderTop: "1px solid rgba(125,125,125,0.12)",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
              }}
            >
              <TextField
                fullWidth
                size="small"
                placeholder="Write a message"
                variant="outlined"
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "var(--body-color-less2)",
                    color: "var(--text-color)",
                    borderRadius: "8px",
                  },
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.target.value.trim()) {
                    sendMessageToTrader(e.target.value);
                    e.target.value = "";
                  }
                }}
              />
              <ContainedButton
                variant="contained"
                onClick={() => sendMessageToTrader(messageText)}
              >
                Send
              </ContainedButton>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Appeal modal */}
      <Dialog
        open={showAppealModal}
        onClose={() => setShowAppealModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: "var(--popupbody-color)",
            color: "var(--text-color)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 0,
            fontWeight: 700,
            color: "var(--text-color)",
            backgroundColor: "var(--popupheader-color)",
          }}
        >
          <Typography variant="h5" fontWeight={600}>
            Before Appealing
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Please read the tips below before submitting an appeal.
          </Typography>
        </DialogTitle>

        <DialogContent dividers sx={{ mt: 1 }}>
          <Stack spacing={2}>
            <Box
              display="flex"
              alignItems="flex-start"
              p={2}
              bgcolor={theme.palette.action.hover}
              borderRadius={2}
            >
              <ChatIcon color="primary" sx={{ mt: 0.5, mr: 2 }} />
              <Typography variant="body1">
                You can upload proof of payment and account info in the
                chatbox to help both parties verify the transaction.
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="flex-start"
              p={2}
              bgcolor={theme.palette.action.hover}
              borderRadius={2}
            >
              <HeadsetMicIcon color="secondary" sx={{ mt: 0.5, mr: 2 }} />
              <Typography variant="body1">
                If you cannot reach the buyer/seller or come to an agreement,
                you may file an appeal.
              </Typography>
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "flex-end", p: 2 }}>
          <OutlinedButton
            variant="outlined"
            onClick={() => {
              setShowAppealModal(false);
            }}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            variant="contained"
            onClick={() => {
              setShowAppealSubmitModal(true);
              // onAppeal(); // open the Submit Appeal modal or handle logic
            }}
          >
            Appeal
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* Appeal submit modal */}
      <Dialog
        open={showAppealSubmitModal}
        onClose={() => setShowAppealSubmitModal(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: "var(--popupbody-color)",
            color: "var(--text-color)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            color: "var(--text-color)",
            backgroundColor: "var(--popupheader-color)",
          }}
        >
          Submit Appeal
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            1. Reason and proofs are visible to both parties and CS. Don't
            include sensitive info.
            <br />
            2. Baseless appeals can lead to bans.
            <br />
            3. CS review may take hours. Submit valid proof.
          </Typography>

          <Box mt={2}>
            <FormControl fullWidth required>
              <InputLabel>Appeal Reason</InputLabel>
              <Select
                value={appealReasonId}
                onChange={(e) => setAppealReasonId(e.target.value)}
                label="Appeal Reason"
              >
                {appealReasonList.map((opt) => (
                  <MenuItem
                    key={opt.appealReasonId}
                    value={opt.appealReasonId}
                  >
                    {opt.appealReasonDetails}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box mt={2}>
            <TextField
              label="Description"
              multiline
              rows={6}
              fullWidth
              required
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              helperText={`${description.length}/500`}
              inputProps={{ maxLength: 500 }}
            />
          </Box>

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              Upload payment proof (pdf, jpg, png, mp3, mp4 etc.)
            </Typography>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              accept=".pdf,.jpg,.jpeg,.png,.mp3,.mp4,.avi,.rm,.rmvb,.mov,.wmv"
              style={{ marginTop: "15px" }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <ContainedButton
            variant="contained"
            onClick={() => setShowAppealSubmitModal(false)}
          >
            Cancel
          </ContainedButton>
          <ContainedButton
            variant="contained"
            onClick={() => createAppeal()}
            disabled={!appealReasonId || !description}
            sx={{ bgcolor: btncolor }}
          >
            Appeal
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* Dialog for displaying bank details */}
      {selectedBankDetails && (
        <ModalContent
          open={showDialogBankDetails}
          onClose={handleCloseDialog}
          title={`Bank Account Details`}
        >
          {[
            {
              label: "Account Holder's Name",
              value: selectedBankDetails.accountHolderName,
            },
            { label: "Bank Name", value: selectedBankDetails.bankName },
            {
              label: "Account Number",
              value: selectedBankDetails.accountNo,
            },
            {
              label: "Account Type",
              value: selectedBankDetails.accountType,
            },
            {
              label: "Identification",
              value: `${selectedBankDetails.identificationType}: ${selectedBankDetails.identificationNumber}`,
            },
            {
              label: "Bank Address",
              value: selectedBankDetails.bankAddress,
            },
          ].map((item, index) => (
            <Box key={index} mb={2}>
              <Typography sx={{ fontWeight: "bold" }}>
                {item.label}
              </Typography>
              <Typography color="text.secondary">{item.value}</Typography>
            </Box>
          ))}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", px: 3, pb: 2 }}
          >
            <ContainedButton onClick={handleCloseDialog}>
              Close
            </ContainedButton>
          </Box>
        </ModalContent>
      )}

      {/* Dialog for displaying wallet details */}
      {selectedWalletDetails && (
        <ModalContent
          open={showDialogWalletDetails}
          onClose={handleCloseDialogWallet}
          title={`Wallet Service Details`}
        >
          <Box mb={2}>
            <Typography sx={{ fontWeight: "bold" }}>
              Payment Provider
            </Typography>
            <Typography sx={{ color: "#95a5a6" }}>
              {selectedWalletDetails.paymentProviderName}
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography sx={{ fontWeight: "bold" }}>Wallet ID</Typography>
            <Typography sx={{ color: "#95a5a6" }}>
              {selectedWalletDetails.walletId}
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography sx={{ fontWeight: "bold" }}>Email ID</Typography>
            <Typography sx={{ color: "#95a5a6" }}>
              {selectedWalletDetails.email_id}
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography sx={{ fontWeight: "bold" }}>Phone Number</Typography>
            <Typography sx={{ color: "#95a5a6" }}>
              {selectedWalletDetails.phone_number}
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography sx={{ fontWeight: "bold" }}>Profile Name</Typography>
            <Typography sx={{ color: "#95a5a6" }}>
              {selectedWalletDetails.profileName}
            </Typography>
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", padding: 2 }}
          >
            <ContainedButton onClick={handleCloseDialogWallet}>
              Close
            </ContainedButton>
          </Box>
        </ModalContent>
      )}
    </>
  );
};

export default OrderDetailsPage;

// ─── Style Constants ────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const statusHeader = {
  mb: 2.5,
  p: 2,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.12)",
};

const statusTitle = {
  fontSize: "1.1rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const twoColLayout = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: 2.5,
  minHeight: "calc(100vh - 200px)",
};

const leftPanel = {
  flex: 3,
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  p: { xs: 2, sm: 3 },
  overflow: "hidden",
};

const rightPanel = {
  flex: 2,
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const sectionTitle = {
  fontSize: "0.9rem",
  fontWeight: 700,
  color: "var(--text-color)",
  mb: 1.5,
};

const modernTableContainer = {
  borderRadius: "10px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
  mt: 1.5,
};

const tableHeadRow = { backgroundColor: "var(--body-color-less2)" };

const tableHeadCell = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.6,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  py: 1.5,
  px: 2,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
};

const tableBodyRow = {
  "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
  "&:last-child td": { borderBottom: 0 },
};

const tableBodyCell = {
  py: 1.5,
  px: 2,
  fontSize: "0.85rem",
  color: "var(--text-color)",
  borderBottom: "1px solid rgba(125,125,125,0.08)",
};
